import theme from '@styles/theme';
export default {
  pageHolder: {
    display: 'flex',
    flexFlow: 'column nowrap',
    width: '100%',
    height: '100vh',
    justifyContent: 'space-between',
    overflowY: 'auto'
  },
  backToCart: {
    padding: ['0 16px', '0 16px', '0 24px', '0 24px', '0 40px'],
    marginTop: '12px',
    width: '100%'
  },
  backToCartHolder: {
    display: 'flex',
    flexFlow: 'row nowrap'
  },
  backToCartText: {
    marginLeft: '8px',
    color: theme.rawColors.darkGrey300,
    fontSize: theme.fontSizes.caption
  },
  section: {
    margin: ['40px auto', '40px auto', '40px auto 80px'],
    padding: ['0 16px', '0 16px', '0 16px', '0 16px', '0 16px', '0 16px', '0'],
    display: ['block', 'block', 'block', 'block', 'flex'],
    flexFlow: ['', '', 'column wrap'],
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: ['100%', '100%', '1529px'],
    '.a-voxButton.-ec': {
      height: '36px',
      fontSize: theme.fontSizes.text
    }
  },
  blocksContainer: {
    display: 'flex',
    flexFlow: ['column wrap', 'column wrap', 'column wrap', 'row nowrap'],
    width: '100%'
  },
  authBlocks: {
    width: ['100%', '100%', '100%', 'calc(29.37%)'],
    display: 'flex',
    flexDirection: ['column', 'column', 'row'],
    flexWrap: ['nowrap', 'nowrap', 'nowrap', 'wrap']
  },
  singleAuthBlocks: (loginGeneral: boolean) => ({
    width: '100%',
    height: 'auto',
    '&:nth-of-type(1)': {
      width: loginGeneral ? '100%' : ['auto', 'auto', '50%', '100%'],
      pr: loginGeneral ? '0' : ['0', '0', '12px', '0']
    },
    '&:nth-of-type(2)': {
      width: ['auto', 'auto', '50%', '100%'],
      pt: ['12px', '12px', '0', '24px'],
      pl: ['0', '0', '12px', '0']
    }
  }),
  newClientBlock: {
    width: ['100%', '100%', '100%', 'calc(70.63%)'],
    minHeight: ['none', 'none', '486px'],
    ml: ['0', '0', '0', '24px'],
    mt: ['24px', '24px', '24px', '0']
  },
  heading: {
    width: '100%',
    pb: ['24px', '24px', '24px', '24px', '40px']
  },
  loading: {
    height: '100vh',
    maxHeight: '720px',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    backgroundColor: 'white'
  }
};